
// stripe services rest api calling

import { routes } from '../config/api_routes'

export const stripeSubscriptionService = {

    // //Stripe Product
    // getProduct: (formData) => window.axios.post(routes.getProductApi, formData),
    // createProduct: (formData) => window.axios.post(routes.createProductApi,formData),
    // getProductById: (formData) => window.axios.post(routes.getProductByIdApi,formData),
    // updateProductById: (formData) => window.axios.post(routes.updateProductByIdApi,formData),

    // //Stipe Price
    // getPrice: (formData) => window.axios.post(routes.getPriceApi,formData),
    // createPrice: (formData) => window.axios.post(routes.createPriceApi,formData),
    // updatePriceStatus: (formData) => window.axios.post(routes.updatePriceStatusApi,formData),

    getProducts: (formData) => window.axios.post(routes.getProductApi, formData),
    createProduct: (formData) => window.axios.post(routes.createProductApi, formData),
    updateProduct: (formData) => window.axios.post(routes.updateProductApi, formData),
    deleteProduct: (formData) => window.axios.post(routes.deleteProductApi, formData),
    getSubscriptions: (formData) => window.axios.post(routes.getSubscriptionsApi, formData),
    createSubscription: (formData) => window.axios.post(routes.createSubscriptionApi, formData),
    updateSubscription: (formData) => window.axios.post(routes.updateSubscriptionApi, formData),
    cancelSubscription: (id) => window.axios.delete(routes.cancelSubscriptionApi + id)
}